import { render, staticRenderFns } from "./IncentiveComparison.vue?vue&type=template&id=a85be412&scoped=true&"
import script from "./IncentiveComparison.vue?vue&type=script&lang=js&"
export * from "./IncentiveComparison.vue?vue&type=script&lang=js&"
import style0 from "./IncentiveComparison.vue?vue&type=style&index=0&id=a85be412&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a85be412",
  null
  
)

export default component.exports